import { createSlice } from "@reduxjs/toolkit";
import {
  fetchBranchTransactionList,
  createOrUpdateBranchTransaction,
  deleteBranchTransaction,
  fetchBranchAccounts,
  fetchBranchTransactionCode,
  fetchToBranches,
  fetchBranchAccs
} from "./branchTransactionThunks";

const branchTransactionSlice = createSlice({
  name: "branchTransaction",
  initialState: {
    branchTransactions: [],
    accounts: [],
    branchCode: "",
    toBranches: [],
    toBrancheAccs : [],
    loading: false,
    error: null,
    successMessage: null,
    selectedBranchTransaction: null,
    isEditBranchTransaction: false,
  },
  reducers: {
    setSelectedBranchTransaction: (state, action) => {
      state.selectedBranchTransaction = action.payload;
    },
    setIsEditBranchTransaction: (state, action) => {
      state.isEditBranchTransaction = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchTransactionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchTransactionList.fulfilled, (state, action) => {
        state.loading = false;
        state.branchTransactions = action.payload;
      })
      .addCase(createOrUpdateBranchTransaction.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteBranchTransaction.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(fetchBranchAccounts.fulfilled, (state, action) => {
        state.accounts = action.payload;
      })
      .addCase(fetchBranchTransactionCode.fulfilled, (state, action) => {
        state.branchCode = action.payload;
      })
      .addCase(fetchToBranches.fulfilled, (state, action) => {
        state.toBranches = action.payload;
      })
      .addCase(fetchBranchAccs.fulfilled, (state, action) => {
        state.toBrancheAccs = action.payload;
      });
  },
});

export const { setSelectedBranchTransaction, setIsEditBranchTransaction } =
  branchTransactionSlice.actions;
export default branchTransactionSlice.reducer;
